import styled from 'styled-components';
import { TStyledLoadingSpinner } from './loading-spinner';

export const StyledLoadingWrapper = styled.div<TStyledLoadingSpinner>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 32rem;
    background-color: ${({ theme, color }) => theme.color[color]};
`;

export const StyledSpinnerWrapper = styled.div`
    height: 8rem;
`;
